<ng-container *ngrxLet="{events: events$, organisationId: organisationId$} as data">
  <ng-container *ngIf="data.events">
    <h1 *ngIf="getOrganisation(data.organisationId)?.organization_name" class="page-title">
      Events by:
      <app-button buttonStyle="unstyled"
                  class="search-results__x-circle-button"
                  [title]="'clear_organizer_filet' | t"
                  (click)="removeOrganisation()">

        <app-icon [name]="ICONS.X_CIRCLE"></app-icon>
      </app-button>
      <span class="search-results__organization">
        {{ getOrganisation(data.organisationId)?.organization_name }}
      </span>
    </h1>

    <ng-container *ngIf="isLoadingOrganizationEvents || (data.organisationId && data.events?.length === 0); else regularSearch">
      <div class="search-results__organization-empty-event-list">
        <app-organization-empty-event-list
          [organization]="getOrganisation(data.organisationId)"></app-organization-empty-event-list>
      </div>
    </ng-container>

    <ng-template #regularSearch>
      <app-search class="search-container"></app-search>

      <div class="col-md-12 p-0">
        <app-result-count [count]="data.events?.length">
          upcoming events
        </app-result-count>

        <div class="row mt-3">
          <div class="col-md-6">
            <app-event-list
              [showActiveEventInline]="showActiveEventInline"
              [activeEventId]="selectedEvent?.event_id ?? null"
              [events]="data.events"
              (eventClicked)="selectEvent($event)"
              (goToEventPageClicked)="selectEvent($event)"
            ></app-event-list>
          </div>
          <div class="col-md-6" *ngIf="!showActiveEventInline">
            <app-event
              *ngIf="selectedEvent"
              [event]="selectedEvent"
              [inline]="true"
              [minified]="false"
              class="event"
              [class.is-mobile]="isMobile$ | ngrxPush"
            ></app-event>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
</ng-container>
